import styles from './Skills.module.css';
import { site } from '../content/site.js';
import Reveal from './Reveal.jsx';

export default function Skills() {
  const s = site.skills;
  return (
    <section className={styles.skills} id="skills">
      <header className="section-head">
        <span className="num" aria-hidden="true">{s.num}</span>
        <h2>{s.title}</h2>
        <p className="meta">{s.meta}</p>
      </header>
      <ul className={styles.list}>
        {s.list.map((skill, i) => (
          <Reveal key={skill.idx} as="li" delay={i * 0.04} className={styles.item}>
            <span className={styles.idx} aria-hidden="true">{skill.idx}</span>
            <span className={styles.arrow} aria-hidden="true">→</span>
            <span className={styles.name}>{skill.name}</span>
            <span className={styles.tag}>{skill.tag}</span>
          </Reveal>
        ))}
      </ul>
    </section>
  );
}
